import React from 'react';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import Computer from 'shared/img/education-onboarding/computer.svg';
import styles from '../Resume/styles.module.scss';

const ViewScholarships = () => (
  <BaseStep
    stepHeader={
      <>
        <Computer className={styles.icon} width={202} />
        See what awards are offered
      </>
    }
    subHeader={
      <>
        View available awards from your college in
        <br />
        your Raise Me account.
      </>
    }
  />
);

export default ViewScholarships;
